import { ownedConnectionFromOwnershipResult } from './ownedCpmMediaResult';
import { requiresOfficialConnection } from './officialConnectionPolicy';

type OwnershipResult = Parameters<typeof ownedConnectionFromOwnershipResult>[0];
export type CampaignSubmissionInput = { campaignId: string; platform: string; url: string; socialConnectionId?: string };
export type SubmitCampaignClipOptions = {
  campaignId: string; platform: string; url: string;
  requireOwnership?: boolean;
  resolveOwnership: (variables: { platform: string; url: string }) => Promise<OwnershipResult>;
  createSubmission: (input: CampaignSubmissionInput) => Promise<unknown>;
  isCurrent?: () => boolean;
  onResolvingOwnership?: (resolving: boolean) => void;
};

/** One ownership/error path for pasted URLs and selected social posts. */
export async function submitCampaignClip({ campaignId, platform, url, requireOwnership = requiresOfficialConnection(platform),
  resolveOwnership, createSubmission, isCurrent = () => true, onResolvingOwnership }: SubmitCampaignClipOptions) {
  const assertCurrent = () => { if (!isCurrent()) throw new Error('import_cancelled'); };
  assertCurrent();
  let socialConnectionId: string | undefined;
  if (requireOwnership) {
    onResolvingOwnership?.(true);
    let result: OwnershipResult;
    try {
      result = await resolveOwnership({ platform, url });
    } finally {
      if (isCurrent()) onResolvingOwnership?.(false);
    }
    assertCurrent();
    const owned = ownedConnectionFromOwnershipResult(result);
    if (!owned.socialConnectionId) throw new Error(owned.errorCode || 'generic');
    socialConnectionId = owned.socialConnectionId;
  }
  assertCurrent();
  return createSubmission({ campaignId, platform, url, ...(socialConnectionId ? { socialConnectionId } : {}) });
}
